import { classNamesFunction, styled } from '@uifabric/utilities';
import * as ReactDOM from 'react-dom';
import * as React from 'react';

const getRootClassNames = () => classNamesFunction();

const PortalBody = ({
  children
}) => /*#__PURE__*/ReactDOM.createPortal(children, document.body);

const getStyledNodeStyles = ({
  className
}) => {
  return {
    root: [className, {// Insert css properties
    }]
  };
};

const getClassNames$1 = getRootClassNames();
/**
 * StyledElement with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Component-Styling)
 */

const StyledElementBase = ({
  attributes,
  children,
  className,
  styles,
  as: Tag = 'div',
  nodeProps
}) => {
  const classNames = getClassNames$1(styles, {
    className
  });
  return /*#__PURE__*/React.createElement(Tag, Object.assign({}, attributes, {
    className: classNames.root
  }, nodeProps), children);
};
const StyledElement = styled(StyledElementBase, getStyledNodeStyles, undefined, {
  scope: 'StyledElement'
});

const getClassNames = getRootClassNames();
/**
 * StyledLeaf with no default styles.
 * [Use the `styles` API to add your own styles.](https://github.com/OfficeDev/office-ui-fabric-react/wiki/Component-Styling)
 */

const StyledLeafBase = ({
  children,
  className,
  styles,
  as: Tag = 'span',
  nodeProps
}) => {
  const classNames = getClassNames(styles, {
    className
  });
  return /*#__PURE__*/React.createElement(Tag, Object.assign({
    className: classNames.root
  }, nodeProps), children);
};
const StyledLeaf = styled(StyledLeafBase, getStyledNodeStyles, undefined, {
  scope: 'StyledLeaf'
});

export { PortalBody, StyledElement, StyledElementBase, StyledLeaf, StyledLeafBase, getRootClassNames, getStyledNodeStyles };
//# sourceMappingURL=index.es.js.map
